// Carrier portali /portal, ru
export default {
  accessOnly: "Доступ только для портала перевозчика.",
  signOut: "Выйти",
  logout: "Выйти",
  title: "Портал перевозчика",
  nav: { candidates: "Кандидаты", jobs: "Вакансии", account: "Аккаунт" },
  poweredBy: "Работает на {{company}}",
  searchPlaceholder: "Поиск кандидатов",
  status: { new: "Новый", in_review: "На рассмотрении", accepted: "Принят", rejected: "Отклонён" },
  all: "Все",
  exp: { none: "—", months: "{{n}} мес.", years_one: "{{count}} год", years_few: "{{count}} года", years_many: "{{count}} лет", years_other: "{{count}} года" },
  allStates: "48 штатов",
  candidates: {
    title: "Кандидаты",
    subtitle: "Водители, направленные в {{carrier}} от {{company}}",
    loadFailed: "Не удалось загрузить кандидатов.",
    emptyTitle: "Кандидатов нет",
    emptySearch: "Ничего не найдено по \"{{q}}\".",
    emptyDesc: "Здесь появятся водители, направленные вашим рекрутером.",
    col: { driver: "Водитель", job: "Вакансия", cdl: "CDL / стаж", state: "Штат", submitted: "Направлен", status: "Статус" },
    count: "{{shown}} из {{total}} кандидатов",
  },
  panel: {
    accepted: "{{name}} принят",
    acceptedDesc: "Рекрутер уведомлён. Водитель переходит на проверку.",
    rejected: "{{name}} отклонён",
    rejectedDesc: "Рекрутер уведомлён.",
    decisionFailed: "Не удалось сохранить решение.",
    submitted: "Направлен {{date}} · {{job}}",
    close: "Закрыть детали",
    phone: "Телефон",
    hidden: "Скрыт рекрутером",
    state: "Штат",
    cdl: "CDL",
    class: "Класс {{cls}}",
    cdlExpires: "CDL истекает",
    medical: "Медкарта",
    validUntil: "действует до {{date}}",
    experience: "Стаж",
    endorsements: "Допуски",
    equipment: "Техника",
    note: "Заметка рекрутера",
    yourReply: "Ваш ответ",
    rejectionReason: "Причина отказа",
    documents: "Документы",
    documentsDesc: "Документы (копия CDL, медкарта) приходят на следующем этапе.",
    notShared: "Перевозчикам не передаются: SSN, дата рождения, внутренние заметки, результаты у других перевозчиков.",
    accept: "Принять",
    reject: "Отклонить",
    acceptTitle: "Принять {{name}}",
    acceptDesc: "Водитель переходит на проверку. Рекрутер получит уведомление.",
    comment: "Комментарий",
    commentPlaceholder: "Необязательный комментарий для рекрутера",
    rejectTitle: "Отклонить {{name}}",
    rejectDesc: "{{job}} · рекрутер увидит причину.",
    confirmReject: "Подтвердить отказ",
    rejectReason: "Причина отказа",
    chooseReason: "Выберите причину",
    reasons: { mvr: "MVR / водительская история", experience: "Стаж", drug: "Тест на наркотики", psp: "PSP / история ДТП", noshow: "Не явился", other: "Другое" },
  },
  jobs: {
    title: "Вакансии",
    subtitle: "Ваши открытые позиции и кандидаты по каждой",
    loadFailed: "Не удалось загрузить вакансии.",
    emptyTitle: "Вакансий пока нет",
    emptyDesc: "Рекрутер добавляет позиции от вашего имени.",
    col: { job: "Вакансия", status: "Статус", states: "Штаты", openings: "Мест", pay: "Оплата", homeTime: "Дома", equipment: "Техника", candidates: "Кандидаты", inReview: "На рассмотрении", hired: "Нанято" },
    hiredOf: "нанято {{hired}} из {{openings}}",
  },
  account: {
    title: "Аккаунт",
    card: "Ваш аккаунт",
    name: "Имя",
    username: "Логин",
    carrier: "Перевозчик",
    mc: "MC #",
    contact: "Чтобы изменить данные аккаунта, свяжитесь с рекрутером.",
  },
};
